import { useState, useCallback } from 'react';

import { useLazyGetWalletsQuery } from '../api';
import type { IWallet } from '../model/types';

export const useWalletChildren = () => {
  const [children, setChildren] = useState<IWallet[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [trigger] = useLazyGetWalletsQuery();

  const loadChildren = useCallback(
    async (parentId: string) => {
      setIsLoading(true);
      try {
        const result = await trigger(`filter[parent_id]=${parentId}`, false).unwrap();
        setChildren(result.data);
      } catch (error) {
        console.error('Failed to load children:', error);
      } finally {
        setIsLoading(false);
      }
    },
    [trigger],
  );

  return {
    children,
    isLoading,
    loadChildren,
  };
};
